var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5.62 7.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3210e0;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.78,2.31c.69,0,1.38,0,2.07,0,.28,0,.42,.16,.41,.44-.05,.81-.11,1.61-.16,2.42-.05,.69-.09,1.38-.14,2.07-.02,.22-.1,.35-.28,.39-.04,0-.08,.01-.13,.01-1.17,0-2.35,0-3.52,0-.25,0-.39-.13-.4-.38-.06-.89-.12-1.77-.18-2.66-.04-.61-.08-1.21-.12-1.82,0-.09,0-.18,.03-.26,.06-.15,.19-.21,.35-.21,.69,0,1.39,0,2.08,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.29,.64V.32c0-.18,.14-.32,.32-.32H3.99c.18,0,.32,.14,.32,.32v.32h.99c.18,0,.32,.14,.32,.32v.36c0,.18-.14,.32-.32,.32H.32c-.18,0-.32-.14-.32-.32v-.35c0-.18,.14-.32,.32-.32h.97Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/TRASH.de956e04b89b9e4bf057489476b88de4.svg";
export { ForwardRef as ReactComponent };